import { IconButton } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';

import { Iconify } from 'src/components/iconify';

import { buildReportViewUrl } from './report-tree-utils';

// ----------------------------------------------------------------------

export function ReportOpenInNewTabButton({ uri, resourceType = 'reportUnit' }) {
  const handleClick = (event) => {
    event.stopPropagation();
    event.preventDefault();
    window.open(buildReportViewUrl(uri, resourceType), '_blank', 'noopener,noreferrer');
  };

  return (
    <Tooltip title="Open in new tab">
      <IconButton
        size="small"
        onClick={handleClick}
        aria-label="Open report in new tab"
        sx={{
          p: 0.25,
          color: 'text.secondary',
          '&:hover': { color: 'primary.main' },
        }}
      >
        <Iconify icon="eva:external-link-outline" width={16} />
      </IconButton>
    </Tooltip>
  );
}
